import styled from "styled-components";

export const Wrapper = styled.div`
  p {
    font-family: "Lato" !important;
    font-weight: 400;
    font-size: 15px !important;
    color: var(--color-text-gray) !important;
    font-weight: ${(props) => (props.bold ? "bold" : "")};
  }
`;
